module.exports = __webpack_public_path__ + "static/media/15.72442fd2.svg";